import Reveal from "./Reveal";

/** Consistent kicker + title + subtitle header used across all homepage sections. */
export default function SectionHeading({
  kicker,
  title,
  subtitle,
  align = "center",
  className = "",
  as = "h2",
  kickerClassName = "text-sm sm:text-base tracking-[0.18em]",
}) {
  const Heading = as;
  const isCenter = align === "center";

  return (
    <Reveal
      className={`${isCenter ? "text-center mx-auto" : "text-left"} mb-10 sm:mb-14 ${className}`}
    >
      {kicker && (
        <span className={`inline-flex items-center gap-2 border rounded-full px-3.5 py-1.5 font-bold uppercase mb-4 bg-accent-soft border-accent/25 text-accent ${kickerClassName}`}>
          <span className="w-1.5 h-1.5 rounded-full bg-gradient-button"></span>
          {kicker}
        </span>
      )}
      <Heading
        className={`text-2xl sm:text-3xl md:text-4xl font-black leading-snug max-w-3xl text-white ${isCenter ? "mx-auto" : ""}`}
      >
        {title}
      </Heading>
      {subtitle && (
        <p className={`mt-3 text-base sm:text-lg max-w-2xl text-ink-secondary ${isCenter ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}
